// components/project-details/ProjectHeader.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, UserIcon, EnvelopeIcon, CalendarIcon, ChatBubbleLeftRightIcon, CheckIcon } from '@heroicons/react/24/outline';
import ProjectStatusBadge from './ProjectStatusBadge';
import CompletionModal from './CompletionModal';
import styles from './ProjectDetails.module.css';

const ProjectHeader = ({ project, onStatusUpdate, updatingStatus }) => {
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const isProjectStarted = project?.status === 'project_started' || project?.status === 'project_completed';

  const handleCompleteProject = () => {
    setShowCompletionModal(false);
    onStatusUpdate(project.id, 'project_completed');
  };

  return (
    <>
      <div className={styles.headerCard}>
        <div className={styles.headerWrapper}>
          <div className={styles.headerLeft}>
            <Link 
              to={isProjectStarted ? "/projects" : "/enquiries"}
              className={styles.backButton}
              aria-label="Go back"
            >
              <ChevronLeftIcon style={{ width: '1.25rem', height: '1.25rem' }} />
            </Link>
            
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)' }}>
                <h1 className={styles.headerTitle}>
                  {project.projectName || 'Project Details'}
                </h1>
                <ProjectStatusBadge status={project.status} />
              </div>
              
              <div className={styles.headerMeta}>
                <span className={styles.metaItem}>
                  <UserIcon style={{ width: '1rem', height: '1rem' }} />
                  {project.customerInfo?.name || 'Unknown Customer'}
                </span>
                <span className={styles.metaItem}>
                  <EnvelopeIcon style={{ width: '1rem', height: '1rem' }} />
                  {project.customerInfo?.email || 'No email provided'}
                </span>
                {project.createdAt && (
                  <span className={styles.metaItem}>
                    <CalendarIcon style={{ width: '1rem', height: '1rem' }} />
                    Created {new Date(project.createdAt.seconds * 1000).toLocaleDateString()}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className={styles.headerActions}>
            {project.status === 'new_enquiry' && (
              <button
                onClick={() => onStatusUpdate(project.id, 'in_conversation')}
                disabled={updatingStatus}
                className={`${styles.actionButton} ${styles.conversation}`}
              >
                {updatingStatus ? (
                  <div className={styles.spinner} style={{ width: '1rem', height: '1rem' }}></div>
                ) : (
                  <ChatBubbleLeftRightIcon style={{ width: '1rem', height: '1rem' }} />
                )}
                I've Emailed the Customer
              </button>
            )}
            {project.status === 'project_started' && (
              <button
                onClick={() => setShowCompletionModal(true)}
                disabled={updatingStatus}
                className={`${styles.actionButton} ${styles.complete}`}
              >
                {updatingStatus ? (
                  <div className={styles.spinner} style={{ width: '1rem', height: '1rem' }}></div>
                ) : (
                  <CheckIcon style={{ width: '1rem', height: '1rem' }} />
                )}
                Mark as Complete
              </button>
            )}
          </div>
        </div>
      </div>

      <CompletionModal
        isOpen={showCompletionModal}
        onClose={() => setShowCompletionModal(false)}
        onConfirm={handleCompleteProject}
        projectName={project.projectName}
      />
    </>
  );
};

export default ProjectHeader;